import React, { useState } from 'react';
import { FileText, Sparkles, CreditCard, CheckCircle, Upload, Download, Target, Shield, Zap, Award, AlertCircle } from 'lucide-react';

const ResumeAnalyzer = () => {
  const [step, setStep] = useState('input');
  const [resume, setResume] = useState('');
  const [jobDescription, setJobDescription] = useState('');
  const [premiumAnalysis, setPremiumAnalysis] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pdfFile, setPdfFile] = useState(null);
 // eslint-disable-next-line no-unused-vars
  const [paymentId, setPaymentId] = useState(null);

// const handlePdfUpload = async (e) => {
//   const file = e.target.files[0];
//   if (!file) return;
  
//   if (file.type !== 'application/pdf') {
//     alert("Please upload a PDF file only.");
//     return;
//   }
  
//   setPdfFile(file);
//   setLoading(true);
  
//   try {
//     // Read file as base64
//     const base64Data = await new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onload = () => {
//         try {
//           const result = reader.result;
//           if (!result) {
//             reject(new Error("Failed to read file"));
//             return;
//           }
//           const base64 = result.split(',')[1];
//           if (!base64) {
//             reject(new Error("Invalid file format"));
//             return;
//           }
//           resolve(base64);
//         } catch (err) {
//           reject(err);
//         }
//       };
//       reader.onerror = () => reject(new Error("File reading failed"));
//       reader.readAsDataURL(file);
//     });

//     console.log("✓ PDF file read, size:", base64Data.length, "chars");
//     console.log("→ Calling backend API at /api/extract-pdf...");
    
//     const response = await fetch("/api/extract-pdf", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         pdfBase64: base64Data
//       })
//     });

//     console.log("✓ Backend responded with status:", response.status);

//     if (!response.ok) {
//       const errorData = await response.json().catch(() => ({}));
//       throw new Error(errorData.error || `API error: ${response.status}`);
//     }

//     const data = await response.json();
    
//     if (!data.success || !data.text) {
//       throw new Error(data.error || "Invalid response from backend");
//     }

//     const extractedText = data.text.trim();
//     console.log("✓ Extracted text length:", extractedText.length);
    
//     if (extractedText.length < 50) {
//       throw new Error(`Extracted text too short (${extractedText.length} chars). PDF may be an image or corrupted.`);
//     }
    
//     // Update state with extracted text
//     setResume(extractedText);
//     setLoading(false);
    
//     console.log("✓✓✓ SUCCESS! Resume text loaded");
//     alert(`✓ Success!\n\nExtracted ${extractedText.length} characters from your PDF.\n\nYou can now proceed to payment.`);
    
//   } catch (err) {
//     console.error("❌ PDF extraction failed:", err);
//     setLoading(false);
//     setPdfFile(null);
    
//     alert(`PDF extraction failed: ${err.message}\n\n⚠️ Please try:\n\n1. Make sure PDF contains selectable text (not a scanned image)\n2. Try re-uploading the PDF\n3. Or paste your resume text manually below`);
//   }
// };


	// terms and conditions link
	// <div className="mb-3">
 //              <a 
 //                href="https://www.brandymage.com/tc" 
 //                target="_blank" 
 //                rel="noopener noreferrer"
 //                className="text-sm text-indigo-600 hover:text-indigo-700 underline font-medium"
 //              >
 //                Terms & Conditions
 //              </a>
 //            </div> 


const handlePdfUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;
  
  if (file.type !== 'application/pdf') {
    alert("Please upload a PDF file only.");
    return;
  }
  
  setPdfFile(file);
  setLoading(true);
  
  try {
    console.log("→ Reading PDF file...");
    
    // Read file as ArrayBuffer for PDF.js
    const arrayBuffer = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(new Error("Failed to read file"));
      reader.readAsArrayBuffer(file);
    });

    console.log("✓ PDF file loaded, size:", arrayBuffer.byteLength, "bytes");

    // Check if PDF.js is available
    if (typeof window.pdfjsLib === 'undefined') {
      throw new Error("PDF.js library not loaded. Please refresh the page.");
    }

    console.log("→ Extracting text with PDF.js (FREE - no API cost!)...");

    // Load PDF document
    const pdf = await window.pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    console.log("✓ PDF loaded, pages:", pdf.numPages);

    // Extract text from all pages
    let fullText = '';
    
    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const textContent = await page.getTextContent();
      
      const pageText = textContent.items
        .map(item => item.str)
        .join(' ')
        .replace(/\s+/g, ' ')
        .trim();
      
      fullText += pageText + '\n\n';
      console.log(`✓ Page ${pageNum}/${pdf.numPages} extracted`);
    }

    fullText = fullText.trim();
    console.log("✓ Total extracted text length:", fullText.length, "characters");

    if (fullText.length < 50) {
      throw new Error(
        "Could not extract enough text from PDF. " +
        "The PDF might be a scanned image. " +
        "Please paste your resume text manually below."
      );
    }

    setResume(fullText);
    setLoading(false);
    
    console.log("✓✓✓ SUCCESS! Resume text extracted (FREE!)");
    alert(`✓ Success!\n\nExtracted ${fullText.length} characters from your PDF.\n\nYou can now proceed to payment.`);
    
  } catch (err) {
    console.error("❌ PDF extraction failed:", err);
    setLoading(false);
    setPdfFile(null);
    
    alert(
      `PDF extraction failed: ${err.message}\n\n` +
      `⚠️ Please try:\n\n` +
      `1. Make sure PDF contains selectable text (not a scanned image)\n` +
      `2. Try a different PDF\n` +
      `3. Or paste your resume text manually below`
    );
  }
};

	

  const proceedToPayment = () => {
    if (!resume || !jobDescription) {
      alert("Please provide both resume and job description");
      return;
    }
    setStep('payment');
  };

  const initiatePayment = () => {
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: 29900,
      currency: "INR",
      name: "BrandyMage Resume Analyzer",
      description: "AI-Powered Resume Analysis",
      handler: async function (response) {
        console.log("Payment successful:", response.razorpay_payment_id);
        setPaymentId(response.razorpay_payment_id);
        setStep('processing');
        await generateAnalysis(response.razorpay_payment_id);
      },
      prefill: {
        name: "", email: "", contact: ""
      },
      theme: {
        color: "#6366f1"
      },
      modal: {
        ondismiss: function() {
          alert("Payment cancelled. Please complete payment to get your analysis.");
        }
      }
    };

    if (window.Razorpay) {
      const rzp = new window.Razorpay(options);
      rzp.open();
    } else {
      alert("Demo mode: Proceeding without payment for testing...");
      setPaymentId("demo_" + Date.now());
      setStep('processing');
      generateAnalysis("demo_" + Date.now());
    }
  };

//   const generateAnalysis = async (paymentId) => {
//     try {
//       const response = await fetch("/api/analyze", {
//   method: "POST",
//   headers: {
//     "Content-Type": "application/json",
//   },
//         body: JSON.stringify({
//           model: "claude-sonnet-4-20250514",
//           max_tokens: 8000,
//           messages: [
//             {
//               role: "user",
//               content: `You are an expert resume analyst. Analyze this ACTUAL resume against the job description.

// ⚠️ CRITICAL RULES - READ CAREFULLY:
// 1. Extract the candidate's REAL NAME from the resume (usually at the top)
// 2. Use ONLY information that actually exists in this resume
// 3. DO NOT invent, fabricate, or make up any experiences, skills, or achievements
// 4. Quote EXACT text from the resume for the "original" sections
// 5. When suggesting improvements, enhance what's ACTUALLY there - don't add fake content
// 6. Identify REAL keywords missing from resume by comparing to job description
// 7. Base ATS score on ACTUAL resume structure and formatting

// RESUME TO ANALYZE:
// ${resume}

// JOB DESCRIPTION TO MATCH:
// ${jobDescription}

// Return ONLY valid JSON (no markdown, no backticks):
// {
//   "candidateName": "EXTRACT ACTUAL NAME FROM RESUME - first name and last name found at the top",
//   "atsScore": 75,
//   "strengths": [
//     "REAL strength 1 based on actual resume content",
//     "REAL strength 2 based on actual resume content", 
//     "REAL strength 3 based on actual resume content"
//   ],
//   "detailedRewrites": [
//     {
//       "section": "ACTUAL section name from resume (e.g., 'Professional Summary', 'Work Experience - [Actual Job Title]')",
//       "original": "COPY EXACT TEXT from the actual resume - word for word",
//       "rewritten": "IMPROVE the exact text above - make it stronger with metrics/action verbs",
//       "explanation": "Explain what specific changes were made and why"
//     },
//     {
//       "section": "ANOTHER ACTUAL section from resume",
//       "original": "EXACT TEXT from resume",
//       "rewritten": "IMPROVED version with quantifiable results",
//       "explanation": "Why this improvement works"
//     },
//     {
//       "section": "ANOTHER ACTUAL section from resume",
//       "original": "EXACT TEXT from resume",
//       "rewritten": "IMPROVED version",
//       "explanation": "Reasoning"
//     }
//   ],
//   "atsOptimization": {
//     "formatting": [
//       "Specific formatting recommendation based on ACTUAL resume structure",
//       "Another recommendation based on what's actually in the resume",
//       "Third recommendation"
//     ],
//     "keywords": {
//       "missing": ["keyword from JOB DESCRIPTION that's NOT in resume", "another missing keyword", "third missing keyword"],
//       "present": ["keyword from JOB DESCRIPTION that IS in resume", "another present keyword", "third present keyword"]
//     },
//     "sections": [
//       "Recommendation about actual sections in resume",
//       "Another recommendation",
//       "Third recommendation"
//     ]
//   },
//   "coverLetter": "Write a professional cover letter using the candidate's ACTUAL NAME and REAL experiences from their resume. Reference specific achievements that actually appear in the resume. Address it to 'Hiring Manager' and sign with the candidate's actual name."
// }

// Remember: Use ONLY real information from the resume. No fabrication.`
//             }
//           ],
//         })
//       });

// 		const data = await response.json();
// 		console.log("Raw API response:", data);

// 		if (!data.success) {
//  		 throw new Error(data.error || "Analysis failed");
// 		}

// 		let text = data.analysis;
//       	console.log("Response text:", text);
      
//       // Clean up the response - remove markdown code blocks if present
//       text = text.replace(/```json\n?/g, '').replace(/```\n?/g, '').trim();
      
//       let parsed;
//       try {
//         parsed = JSON.parse(text);
//       } catch (parseError) {
//         console.error("JSON parse error:", parseError);
//         console.log("Text being parsed:", text);
//         throw new Error("Failed to parse AI response. The AI returned invalid JSON.");
//       }
      
//       // Store payment ID
//       parsed.paymentId = paymentId;
      
//       console.log("Parsed analysis:", parsed);
//       setPremiumAnalysis(parsed);
//       setStep('results');
      
//     } catch (err) {
//       console.error("Analysis error:", err);
//       alert(`Analysis failed: ${err.message}\n\nPlease try again or contact support.`);
//       setStep('payment');
//     }
//   };



const generateAnalysis = async (pId) => {
  try {
    const response = await fetch("/api/analyze", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        paymentId: pId,
        resume: resume,
        jobDescription: jobDescription
      })
    });

    const data = await response.json();
    console.log("Raw API response:", data);

    if (!data.success) {
      throw new Error(data.error || "Analysis failed");
    }

    let text = data.analysis;
    console.log("Response text:", text);
    
    // Clean up the response - remove markdown code blocks if present
    text = text.replace(/```json\n?/g, '').replace(/```\n?/g, '').trim();
    
    let parsed;
    try {
      parsed = JSON.parse(text);
    } catch (parseError) {
      console.error("JSON parse error:", parseError);
      console.log("Text being parsed:", text);
      throw new Error("Failed to parse AI response. The AI returned invalid JSON.");
    }
    
    // Store payment ID
    parsed.paymentId = pId;
    
    console.log("Parsed analysis:", parsed);
    setPremiumAnalysis(parsed);
    setStep('results');
    
  } catch (err) {
    console.error("Analysis error:", err);
    alert(`Analysis failed: ${err.message}\n\nPlease try again or contact support.`);
    setStep('payment');
  }
};
	

  const downloadCoverLetter = () => {
    try {
      if (!premiumAnalysis || !premiumAnalysis.coverLetter) {
        alert("No cover letter available to download.");
        return;
      }

      console.log("Starting PNG download process...");

      // Replace [Your Name] with actual name
      let coverLetterText = premiumAnalysis.coverLetter;
      if (premiumAnalysis.candidateName) {
        coverLetterText = coverLetterText.replace(/\[Your Name\]/g, premiumAnalysis.candidateName);
      }

      // Create canvas element
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      if (!ctx) {
        throw new Error("Canvas context not available");
      }

      console.log("Canvas created successfully");
      
      // Set canvas dimensions (A4 aspect ratio)
      canvas.width = 1200;
      canvas.height = 1600;
      
      // Fill white background
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      console.log("Drawing watermark...");
      
      // Draw BM watermark in center (very subtle)
      ctx.save();
      ctx.globalAlpha = 0.03; // Very faint
      ctx.translate(canvas.width / 2, canvas.height / 2);
      
      // Draw circle
      ctx.strokeStyle = '#2d1b4e';
      ctx.lineWidth = 3;
      ctx.setLineDash([10, 10]);
      ctx.beginPath();
      ctx.arc(0, 0, 200, 0, Math.PI * 2);
      ctx.stroke();
      
      // Draw BM text
      ctx.fillStyle = '#2d1b4e';
      ctx.font = 'bold 180px serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('BM', 0, 20);
      
      // Draw small decorative circles
      const positions = [[-130, -200], [130, -200], [-130, 200], [130, 200]];
      positions.forEach(([x, y]) => {
        ctx.beginPath();
        ctx.arc(x, y, 8, 0, Math.PI * 2);
        ctx.fill();
      });
      
      ctx.restore();
      
      console.log("Drawing header...");
      
      // Draw header
      ctx.fillStyle = '#4F46E5';
      ctx.font = 'bold 32px Arial';
      ctx.textAlign = 'center';
      ctx.fillText('COVER LETTER', canvas.width / 2, 70);
      
      // Draw subheader
      ctx.fillStyle = '#6B7280';
      ctx.font = '16px Arial';
      ctx.fillText('Generated by BrandyMage Resume Analyzer', canvas.width / 2, 105);
      
      // Draw top line
      ctx.strokeStyle = '#D1D5DB';
      ctx.lineWidth = 2;
      ctx.setLineDash([]);
      ctx.beginPath();
      ctx.moveTo(100, 135);
      ctx.lineTo(canvas.width - 100, 135);
      ctx.stroke();
      
      console.log("Drawing cover letter text...");
      
      // Draw cover letter text with word wrapping
      ctx.fillStyle = '#1F2937';
      ctx.font = '19px Georgia';
      ctx.textAlign = 'left';
      
      const padding = 100;
      const maxWidth = canvas.width - (padding * 2);
      const lineHeight = 34;
      let y = 180;
      
      // Split into paragraphs
      const paragraphs = coverLetterText.split('\n\n');
      
      paragraphs.forEach((paragraph, pIndex) => {
        const trimmedPara = paragraph.trim();
        if (!trimmedPara) return;
        
        // Handle single-line paragraphs (like "Dear Hiring Manager,")
        const lines = trimmedPara.split('\n');
        
        lines.forEach((line, lIndex) => {
          const trimmedLine = line.trim();
          if (!trimmedLine) return;
          
          const words = trimmedLine.split(' ');
          let currentLine = '';
          
          for (let i = 0; i < words.length; i++) {
            const word = words[i];
            const testLine = currentLine ? currentLine + ' ' + word : word;
            const metrics = ctx.measureText(testLine);
            
            if (metrics.width > maxWidth && currentLine) {
              ctx.fillText(currentLine, padding, y);
              y += lineHeight;
              currentLine = word;
            } else {
              currentLine = testLine;
            }
          }
          
          if (currentLine) {
            ctx.fillText(currentLine, padding, y);
            y += lineHeight;
          }
        });
        
        // Add extra space between paragraphs
        y += lineHeight * 0.4;
      });
      
      console.log("Drawing footer...");
      
      // Draw footer
      const footerY = canvas.height - 100;
      ctx.strokeStyle = '#D1D5DB';
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(100, footerY);
      ctx.lineTo(canvas.width - 100, footerY);
      ctx.stroke();
      
      ctx.fillStyle = '#6B7280';
      ctx.font = 'bold 15px Arial';
      ctx.textAlign = 'center';
      ctx.fillText('© 2025 BrandyMage™', canvas.width / 2, footerY + 35);
      
      ctx.font = '14px Arial';
      ctx.fillText('www.brandymage.com | Support: hello@brandymage.com', canvas.width / 2, footerY + 60);
      
      console.log("Converting to PNG...");
      
      // Convert canvas to blob
      canvas.toBlob((blob) => {
        if (!blob) {
          throw new Error("Failed to create image blob");
        }
        
        console.log("PNG blob created, size:", blob.size, "bytes");
        
        // Create download link
        const url = URL.createObjectURL(blob);
        const filename = `cover-letter-${premiumAnalysis.candidateName?.replace(/\s+/g, '-').toLowerCase() || 'candidate'}.png`;
        
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.style.display = 'none';
        
        document.body.appendChild(a);
        a.click();
        
        // Clean up
        setTimeout(() => {
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
          console.log("✓ Download complete!");
        }, 100);
        
        // Show success message
        alert(`✓ Cover letter downloaded!\n\nYou can print it directly or attach to emails.`);
        
      }, 'image/png', 0.95);
      
    } catch (error) {
      console.error('❌ Download error:', error);
      alert(`Download failed: ${error.message}\n\nPlease try again or contact support at hello@brandymage.com`);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex flex-col">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
  			src="/brandymage-logo.png" 
  			alt="BrandyMage Logo" 
  			className="w-12 h-12 rounded-lg"
		/>

            <div>
              <div className="font-bold text-gray-900 text-lg">BrandyMage</div>
              <div className="text-xs text-gray-500">Resume Analyzer Pro</div>
            </div>
          </div>
          <div className="text-sm text-gray-600">
            Powered by AI
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 p-6">
        <div className="max-w-4xl mx-auto">
          
          {/* Input Step */}
          {step === 'input' && (
            <>
              <div className="text-center mb-8">
                <div className="flex items-center justify-center gap-2 mb-3">
                  <Sparkles className="w-8 h-8 text-indigo-600" />
                  <h1 className="text-4xl font-bold text-gray-900">Resume Analyzer Pro</h1>
                </div>
                <p className="text-gray-600 text-lg mb-2">AI-powered resume optimization with ATS analysis</p>
                <div className="inline-flex items-center gap-2 bg-indigo-100 text-indigo-800 px-4 py-2 rounded-full font-semibold">
                  <Zap className="w-5 h-5" />
                  One-time payment: ₹299
                </div>
              </div>

              {/* Features Grid */}
              <div className="grid md:grid-cols-3 gap-4 mb-8">
                <div className="bg-white p-6 rounded-xl shadow-md border-2 border-indigo-100">
                  <Target className="w-8 h-8 text-indigo-600 mb-3" />
                  <h3 className="font-bold text-gray-900 mb-2">ATS Optimization</h3>
                  <p className="text-sm text-gray-600">Beat applicant tracking systems with keyword optimization</p>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-md border-2 border-purple-100">
                  <Award className="w-8 h-8 text-purple-600 mb-3" />
                  <h3 className="font-bold text-gray-900 mb-2">Detailed Rewrites</h3>
                  <p className="text-sm text-gray-600">Section-by-section improvements with explanations</p>
                </div>
                <div className="bg-white p-6 rounded-xl shadow-md border-2 border-green-100">
                  <FileText className="w-8 h-8 text-green-600 mb-3" />
                  <h3 className="font-bold text-gray-900 mb-2">Custom Cover Letter</h3>
                  <p className="text-sm text-gray-600">Personalized cover letter based on your experience</p>
                </div>
              </div>

              <div className="bg-white rounded-2xl shadow-xl p-8">
                <div className="space-y-6">
                  <div>
                    <label className="flex items-center gap-2 text-lg font-semibold text-gray-700 mb-3">
                      <FileText className="w-5 h-5" />
                      Your Resume
                    </label>
                    
                    <div className="mb-4">
                      <label className="flex items-center justify-center gap-2 w-full p-6 border-2 border-dashed border-indigo-300 rounded-xl hover:border-indigo-500 cursor-pointer transition-all bg-indigo-50 hover:bg-indigo-100">
                        <Upload className="w-5 h-5 text-indigo-600" />
                        <span className="text-indigo-600 font-medium">
                          {pdfFile ? `✓ ${pdfFile.name}` : 'Upload PDF Resume'}
                        </span>
                        <input
                          type="file"
                          accept=".pdf"
                          onChange={handlePdfUpload}
                          className="hidden"
                        />
                      </label>
                      {loading && (
                        <div className="mt-2 text-center text-indigo-600 text-sm flex items-center justify-center gap-2">
                          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-indigo-600"></div>
                          Extracting text from PDF... This may take 10-15 seconds
                        </div>
                      )}
                      {pdfFile && resume && !loading && (
                        <div className="mt-2 text-center text-green-600 text-sm font-semibold">
                          ✓ PDF extracted! {resume.length} characters loaded
                        </div>
                      )}
                    </div>

                    <div className="text-center text-gray-500 text-sm mb-3">or paste text below</div>

                    <textarea
                      value={resume}
                      onChange={(e) => setResume(e.target.value)}
                      placeholder="Paste your complete resume text here (include name, contact, experience, education, skills, etc.)..."
                      className="w-full h-48 p-4 border-2 border-gray-200 rounded-xl focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-all resize-none font-mono text-sm"
                    />
                    {resume && (
                      <div className="mt-2 text-xs text-gray-500 flex items-center justify-between">
                        <span>✓ Resume loaded ({resume.length} characters)</span>
                        <button
                          type="button"
                          onClick={() => {
                            setResume('');
                            setPdfFile(null);
                          }}
                          className="text-red-600 hover:text-red-700 font-medium"
                        >
                          Clear
                        </button>
                      </div>
                    )}
                  </div>

                  <div>
                    <label className="flex items-center gap-2 text-lg font-semibold text-gray-700 mb-3">
                      <Target className="w-5 h-5" />
                      Job Description
                    </label>
                    <textarea
                      value={jobDescription}
                      onChange={(e) => setJobDescription(e.target.value)}
                      placeholder="Paste the complete job description here..."
                      className="w-full h-48 p-4 border-2 border-gray-200 rounded-xl focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 transition-all resize-none"
                    />
                    {jobDescription && (
                      <div className="mt-2 text-xs text-gray-500 flex items-center justify-between">
                        <span>✓ Job description loaded ({jobDescription.length} characters)</span>
                        <button
                          type="button"
                          onClick={() => setJobDescription('')}
                          className="text-red-600 hover:text-red-700 font-medium"
                        >
                          Clear
                        </button>
                      </div>
                    )}
                  </div>

                  <button
                    onClick={proceedToPayment}
                    disabled={!resume || !jobDescription}
                    className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-4 rounded-xl font-semibold text-lg hover:from-indigo-700 hover:to-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2 shadow-lg hover:shadow-xl"
                  >
                    {!resume && !jobDescription ? (
                      <>Add Resume & Job Description to Continue</>
                    ) : !resume ? (
                      <>Add Resume to Continue</>
                    ) : !jobDescription ? (
                      <>Add Job Description to Continue</>
                    ) : (
                      <>
                        Continue to Payment
                        <CreditCard className="w-5 h-5" />
                      </>
                    )}
                  </button>
                </div>
              </div>
            </>
          )}

          {/* Payment Step */}
          {step === 'payment' && (
            <div className="max-w-2xl mx-auto">
              <div className="text-center mb-8">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-indigo-100 rounded-full mb-4">
                  <Shield className="w-8 h-8 text-indigo-600" />
                </div>
                <h2 className="text-3xl font-bold text-gray-900 mb-3">Secure Payment</h2>
                <p className="text-gray-600">Complete your payment to get instant AI-powered analysis</p>
              </div>

              <div className="bg-white rounded-2xl shadow-xl p-8 mb-6">
                <div className="border-2 border-indigo-100 rounded-xl p-6 mb-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-4">What You'll Get:</h3>
                  <div className="space-y-3">
                    <div className="flex items-start gap-3">
                      <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                      <div>
                        <div className="font-semibold text-gray-900">ATS Optimization Score & Report</div>
                        <div className="text-sm text-gray-600">Understand how your resume performs against applicant tracking systems</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                      <div>
                        <div className="font-semibold text-gray-900">Detailed Section-by-Section Rewrites</div>
                        <div className="text-sm text-gray-600">Before/after comparisons with explanations for each improvement</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                      <div>
                        <div className="font-semibold text-gray-900">Keyword Gap Analysis</div>
                        <div className="text-sm text-gray-600">Missing keywords from the job description that you should add</div>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                      <div>
                        <div className="font-semibold text-gray-900">Custom Cover Letter (Downloadable)</div>
                        <div className="text-sm text-gray-600">Personalized cover letter using your actual experience</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-xl p-6 mb-6">
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-lg font-semibold text-gray-900">Total Amount</span>
                    <span className="text-3xl font-bold text-indigo-600">₹299</span>
                  </div>
                  <div className="text-sm text-gray-600 mb-4">
                    <div className="flex items-center gap-2 mb-1">
                      <CheckCircle className="w-4 h-4 text-green-600" />
                      <span>One-time payment, no subscription</span>
                    </div>
                    <div className="flex items-center gap-2 mb-1">
                      <CheckCircle className="w-4 h-4 text-green-600" />
                      <span>Instant delivery (60-90 seconds)</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <CheckCircle className="w-4 h-4 text-green-600" />
                      <span>Secure payment via Razorpay</span>
                    </div>
                  </div>
                  <div className="text-xs text-red-600 font-semibold">
                    ⚠️ Payment is non-refundable
                  </div>
                </div>

                <button
                  onClick={initiatePayment}
                  className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-4 rounded-xl font-semibold text-lg hover:from-indigo-700 hover:to-purple-700 transition-all flex items-center justify-center gap-2 shadow-lg hover:shadow-xl"
                >
                  <CreditCard className="w-5 h-5" />
                  Pay ₹299 & Get Analysis
                </button>

                <button
                  onClick={() => setStep('input')}
                  className="w-full text-gray-600 hover:text-gray-900 py-3 font-medium transition-colors mt-4"
                >
                  ← Back to Edit
                </button>
              </div>

              <div className="text-center text-sm text-gray-500">
                <Shield className="w-4 h-4 inline mr-1" />
                Secured by Razorpay • 256-bit SSL encryption
              </div>
            </div>
          )}

          {/* Processing Step */}
          {step === 'processing' && (
            <div className="bg-white rounded-2xl shadow-xl p-12 text-center max-w-2xl mx-auto">
              <div className="animate-spin rounded-full h-16 w-16 border-4 border-indigo-200 border-t-indigo-600 mx-auto mb-6"></div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">Payment Successful! ✓</h2>
              <p className="text-gray-600 mb-4">Our AI is analyzing your resume in detail...</p>
              <div className="text-sm text-gray-500">This usually takes 60-90 seconds</div>
              <div className="mt-6 text-xs text-indigo-600">
                Extracting your information, comparing with job description, generating personalized recommendations...
              </div>
            </div>
          )}

          {/* Results Step */}
          {step === 'results' && premiumAnalysis && (
            <div className="space-y-6">
              <div className="bg-white rounded-2xl shadow-xl p-8">
                <div className="flex items-center justify-between mb-6 flex-wrap gap-4">
                  <div>
                    <h2 className="text-3xl font-bold text-gray-900">Your Analysis Report</h2>
                    {premiumAnalysis.candidateName && (
                      <p className="text-gray-600 mt-1">Prepared for: <span className="font-semibold text-indigo-600">{premiumAnalysis.candidateName}</span></p>
                    )}
                  </div>
                  <button
                    onClick={downloadCoverLetter}
                    className="flex items-center gap-2 px-5 py-3 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg hover:from-green-600 hover:to-green-700 transition-all shadow-lg hover:shadow-xl font-semibold"
                  >
                    <Download className="w-5 h-5" />
                    Download Cover Letter
                  </button>
                </div>

                {/* ATS Score */}
                <div className="mb-8 p-6 bg-gradient-to-r from-indigo-50 to-purple-50 rounded-xl border-2 border-indigo-100">
                  <div className="flex items-center gap-3 mb-4">
                    <Target className="w-6 h-6 text-indigo-600" />
                    <h3 className="text-xl font-bold text-gray-900">ATS Optimization Score</h3>
                  </div>
                  <div className="flex items-center gap-4 mb-4">
                    <div className="text-5xl font-bold text-indigo-600">{premiumAnalysis.atsScore}</div>
                    <div className="text-gray-600">
                      <div className="font-semibold">
                        {premiumAnalysis.atsScore >= 80 ? "Excellent!" : premiumAnalysis.atsScore >= 70 ? "Good!" : "Needs Improvement"}
                      </div>
                      <div className="text-sm">Your resume is {premiumAnalysis.atsScore >= 70 ? "well" : "partially"} optimized for ATS</div>
                    </div>
                  </div>
                  <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded">
                    <div className="flex items-start gap-2">
                      <AlertCircle className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" />
                      <div className="text-sm text-yellow-800">
                        <span className="font-semibold">Make the following improvements to increase your ATS score:</span> Apply the detailed rewrites below, add the missing keywords, and follow the formatting recommendations to boost your score to 85+.
                      </div>
                    </div>
                  </div>
                </div>

                {/* Strengths */}
                {premiumAnalysis.strengths && premiumAnalysis.strengths.length > 0 && (
                  <div className="mb-8">
                    <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                      <CheckCircle className="w-6 h-6 text-green-600" />
                      Key Strengths in Your Resume
                    </h3>
                    <div className="space-y-3">
                      {premiumAnalysis.strengths.map((strength, idx) => (
                        <div key={idx} className="flex items-start gap-3 p-4 bg-green-50 rounded-lg border-l-4 border-green-500">
                          <div className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                          <span className="text-gray-700">{strength}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Detailed Rewrites */}
                <div className="mb-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <Sparkles className="w-6 h-6 text-indigo-600" />
                    Detailed Rewrites from Your Resume
                  </h3>
                  <p className="text-sm text-gray-600 mb-6">These improvements are based on your actual resume content. Apply these changes to strengthen your application.</p>
                  <div className="space-y-6">
                    {premiumAnalysis.detailedRewrites.map((rewrite, idx) => (
                      <div key={idx} className="border-l-4 border-indigo-500 pl-6 py-3 bg-gray-50 rounded-r-lg">
                        <div className="font-bold text-lg text-gray-900 mb-3 flex items-center gap-2">
                          <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm">Section {idx + 1}</span>
                          {rewrite.section}
                        </div>
                        <div className="mb-4">
                          <div className="text-sm font-semibold text-red-700 mb-2 flex items-center gap-2">
                            <span className="bg-red-100 px-2 py-1 rounded">BEFORE</span>
                            (Your current resume)
                          </div>
                          <div className="text-gray-700 bg-red-50 p-4 rounded border-l-4 border-red-300 italic">
                            "{rewrite.original}"
                          </div>
                        </div>
                        <div className="mb-4">
                          <div className="text-sm font-semibold text-green-700 mb-2 flex items-center gap-2">
                            <span className="bg-green-100 px-2 py-1 rounded">AFTER</span>
                            (Improved version)
                          </div>
                          <div className="text-gray-900 bg-green-50 p-4 rounded border-l-4 border-green-500 font-medium">
                            "{rewrite.rewritten}"
                          </div>
                        </div>
                        <div className="text-sm text-indigo-700 bg-indigo-50 p-4 rounded border-l-4 border-indigo-300">
                          <span className="font-semibold">💡 Why this works:</span> {rewrite.explanation}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* ATS Formatting */}
                <div className="mb-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <Target className="w-6 h-6 text-purple-600" />
                    ATS Formatting Recommendations
                  </h3>
                  <p className="text-sm text-gray-600 mb-4">Follow these guidelines to ensure ATS systems can read your resume:</p>
                  <div className="space-y-3">
                    {premiumAnalysis.atsOptimization.formatting.map((rec, idx) => (
                      <div key={idx} className="flex items-start gap-3 p-4 bg-purple-50 rounded-lg border-l-4 border-purple-400">
                        <span className="bg-purple-200 text-purple-800 px-2 py-1 rounded font-bold text-sm flex-shrink-0">{idx + 1}</span>
                        <span className="text-gray-700">{rec}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Keyword Analysis */}
                <div className="mb-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Keyword Analysis</h3>
                  <p className="text-sm text-gray-600 mb-4">Comparison between job description keywords and your resume:</p>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="p-5 bg-red-50 rounded-lg border-2 border-red-200">
                      <div className="font-bold text-red-900 mb-3 flex items-center gap-2">
                        <AlertCircle className="w-5 h-5" />
                        Missing Keywords (Add These!)
                      </div>
                      <div className="flex flex-wrap gap-2">
                        {premiumAnalysis.atsOptimization.keywords.missing.map((kw, idx) => (
                          <span key={idx} className="px-3 py-1.5 bg-red-200 text-red-900 rounded-full text-sm font-semibold">
                            + {kw}
                          </span>
                        ))}
                      </div>
                    </div>
                    <div className="p-5 bg-green-50 rounded-lg border-2 border-green-200">
                      <div className="font-bold text-green-900 mb-3 flex items-center gap-2">
                        <CheckCircle className="w-5 h-5" />
                        Present Keywords (Good!)
                      </div>
                      <div className="flex flex-wrap gap-2">
                        {premiumAnalysis.atsOptimization.keywords.present.map((kw, idx) => (
                          <span key={idx} className="px-3 py-1.5 bg-green-200 text-green-900 rounded-full text-sm font-semibold">
                            ✓ {kw}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Section Recommendations */}
                <div className="mb-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Section & Structure Recommendations</h3>
                  <div className="space-y-3">
                    {premiumAnalysis.atsOptimization.sections.map((sec, idx) => (
                      <div key={idx} className="flex items-start gap-3 p-4 bg-blue-50 rounded-lg border-l-4 border-blue-400">
                        <Sparkles className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">{sec}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Cover Letter Preview */}
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <FileText className="w-6 h-6 text-indigo-600" />
                    Your Custom Cover Letter
                  </h3>
                  <p className="text-sm text-gray-600 mb-4">
                    This cover letter is personalized using your actual name and experiences from your resume.
                  </p>
                  <div className="p-6 bg-gray-50 rounded-lg border-2 border-gray-200">
                    <pre className="whitespace-pre-wrap font-sans text-gray-700 leading-relaxed">
                      {premiumAnalysis.candidateName ? 
                        premiumAnalysis.coverLetter.replace(/\[Your Name\]/g, premiumAnalysis.candidateName) : 
                        premiumAnalysis.coverLetter
                      }
                    </pre>
                  </div>
                  <div className="mt-4 flex justify-end">
                    <button
                      onClick={downloadCoverLetter}
                      className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg hover:from-green-600 hover:to-green-700 transition-all shadow-lg font-semibold"
                    >
                      <Download className="w-5 h-5" />
                      Download This Cover Letter
                    </button>
                  </div>
                </div>
              </div>

              <button
                onClick={() => {
                  setStep('input');
                  setResume('');
                  setJobDescription('');
                  setPremiumAnalysis(null);
                  setPdfFile(null);
                  setPaymentId(null);
                }}
                className="w-full bg-indigo-600 text-white py-4 rounded-xl font-semibold text-lg hover:bg-indigo-700 transition-all"
              >
                Analyze Another Resume
              </button>
            </div>
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 mt-auto">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="text-center">
            <div className="font-semibold text-gray-900 mb-2">© 2025 BrandyMage™. All Rights Reserved.</div>
            <div className="text-sm text-gray-600 mb-2">
              Support: <a href="mailto:hello@brandymage.com" className="text-indigo-600 hover:text-indigo-700">hello@brandymage.com</a>
            </div>
            <div className="text-sm text-red-600 font-semibold mb-3">
              ⚠️ All payments are non-refundable
		  </div>
            <div className="text-xs text-gray-500 max-w-3xl mx-auto leading-relaxed">
              BrandyMage operates as a sole proprietorship. We optimize messaging, clarity, and positioning. 
              Results vary due to external hiring factors. We do not fabricate credentials or guarantee employment outcomes.
            </div>
		  </div>
        </div>
      </footer>
    </div>
  );
};

export default ResumeAnalyzer;


